export default __webpack_public_path__ + "static/media/2106_00B.0f10e728.jpg";